import {smoothScrollPause, smoothScrollPlay} from "../scroll-smoother";
import {gsap} from "gsap";
import {Swiper} from "swiper";
import {FreeMode} from "swiper/modules";

$(document).ready(function () {
  window.dataLayer = window.dataLayer || [];

  function gtag() {
    dataLayer.push(arguments);
  }

  function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
        return cookie.substring(name.length + 1);
      }
    }
    return null;
  }

  function setCookie(name, value, days) {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);

    const domain = getDomainFromUrl(); // Get the domain dynamically
    document.cookie = `${name}=${value}; expires=${expirationDate.toUTCString()}; path=/; domain=.${domain}; Secure; SameSite=Lax`;
  }

  function getDomainFromUrl() {
    let hostname = window.location.hostname;

    let parts = hostname.split('.');
    if (parts.length > 2) {
      parts.shift();
    }
    console.log('get domain from url', parts.join('.'));
    return parts.join('.');
  }

  function setCookieCheckbox() {
    $('#confirm-analytical').prop('checked', getCookie('analytical'));
    $('#confirm-marketing').prop('checked', getCookie('marketing'));

  }

  function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  if (!getCookie('necessary')) {
    $(`.js--cookie-popup`).removeClass('hidden');
    $('.js--cookie-floating').addClass("hidden")
  }

  $('.js--customize-cookies').on('click', function () {
    setCookieCheckbox();
    $('.js--accept-customized, .js--customized-cookie-block').removeClass('d-none');
    $(this).addClass('d-none');
  });

  $('.js--cookie-floating').on('click', function () {
    setCookieCheckbox();
    $(`.js--cookie-popup`).removeClass('hidden')
    $('.js--accept-customized, .js--customized-cookie-block').removeClass('d-none');
    $('.js--customize-cookies').addClass('d-none');

    $('.js--cookie-floating').addClass("hidden")
  });

  $('.js--accept-customized').on('click', function (event) {
    let analytics = $('#confirm-analytical').is(":checked");
    let marketing = $('#confirm-marketing').is(":checked");

    setCookie('necessary', true, 365);
    if (analytics) {
      setCookie('analytical', true, 365);
    } else {
      deleteCookie('analytical');
    }
    if (marketing) {
      setCookie('marketing', true, 365);
    } else {
      deleteCookie('marketing');
    }

    gtag('consent', 'update', {
      'ad_user_data': marketing ? 'granted' : 'denied',
      'ad_personalization': marketing ? 'granted' : 'denied',
      'ad_storage': 'granted',
      'analytics_storage': analytics ? 'granted' : 'denied'
    });
    $(`.js--cookie-popup`).addClass('hidden')
    $('.js--cookie-floating').removeClass("hidden")

  });

  $('.js--accept-cookies').on('click', function (event) {
    setCookie('necessary', true, 365);
    setCookie('analytical', true, 365);
    setCookie('marketing', true, 365);
    gtag('consent', 'update', {
      'ad_user_data': 'granted',
      'ad_personalization': 'granted',
      'ad_storage': 'granted',
      'analytics_storage': 'granted'
    });
    $(`.js--cookie-popup`).addClass('hidden')
    $('.js--cookie-floating').removeClass("hidden")
  });

  $('.js--privacy-policy-close').on('click', function () {
    const modal = $('.js--privacy-policy-modal')
    setPrivacyPolicyGetRequest('privacy_policy', false);
    setPrivacyPolicyGetRequest('active_tab', false);
    modal.removeClass('active');
    if ($('.modal-active').length === 0) {
      $('body').removeClass('overflow-hidden');
      $('html').removeClass('overflow-hidden');
      smoothScrollPlay();
    }
  });

  $('.js--privacy-policy-open').on('click', function (event) {
    event.preventDefault();
    const modal = $('.js--privacy-policy-modal')
    setPrivacyPolicyGetRequest();
    modal.addClass('active');
    $('body').addClass('overflow-hidden');
    $('html').addClass('overflow-hidden');
    smoothScrollPause();

    if ($(this).data('tab-id')) {
      $(`#${$(this).data('tab-id')}`).click();
    }
  });

  const setPrivacyPolicyGetRequest = (key = 'privacy_policy', value = 'true') => {
    const newUrl = new URL(window.location.href);
    if (value) {
      newUrl.searchParams.set(key, value);
    } else {
      newUrl.searchParams.delete(key);
    }
    window.history.pushState({}, '', newUrl);
  }

  $('.js--change-privacy-tab').on('click', function () {
    $('.js--change-privacy-tab').removeClass('active-tab');
    $(this).addClass('active-tab');
    setPrivacyPolicyGetRequest('active_tab', $(this)[0].id || false);
    $("[data-privacy-page]").removeClass('active-page');
    $(`[data-privacy-page="${$(this).data('privacy-type')}"]`).addClass('active-page');
    gsap.fromTo('.inner-content .active-page', {opacity: 0, y: 50}, {opacity: 1, y: 0, duration: 0.5})
  });


  new Swiper('.js--cookie-tab-swiper', {
    modules: [FreeMode],
    spaceBetween: 0,
    slidesPerView: 'auto',
    freeMode: {
      enabled: true
    },
    loop: false
  })
});
